const types = {
  MOBILITY_FILE_SELECTED: 'MOBILITY_FILE_SELECTED',
  MOBILITY_UPLOAD_PENDING: 'MOBILITY_UPLOAD_PENDING',
  MOBILITY_UPLOAD_SUCCESS: 'MOBILITY_UPLOAD_SUCCESS',
  MOBILITY_UPLOAD_ERROR: 'MOBILITY_UPLOAD_ERROR',
  RESET_STORE: 'RESET_STORE',
};

export default types;
